/* eslint no-console: "off" */
import axios from 'axios';
import auth from '@/common/auth';

export default {
  checkIfGameToResumeExists({ commit, rootState }) {
    console.log(`Invoking api/gameToResumeExists?msisdn=${rootState.common.userDetails.msisdn}`);
    return axios({
      method: 'get',
      url: 'api/gameToResumeExists',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const responseData = response.data;
      if (responseData.responseEnum === 'NO_GAME_EXISTS') {
        console.log('NO_GAME_EXISTS');
        commit('setGameInProgress', false);
      } else if (responseData.responseEnum === 'PENDING_GAME_EXISTS') {
        console.log('PENDING_GAME_EXISTS');
        commit('setGameInProgress', true);
      }
    }).catch((error) => {
      console.log(`Invoking api/gameToResumeExists failed with the following error: ${error}`);
    });
  },
  checkIfGameToResumeExistsForUnauthorizedUsers({ rootState }) {
    console.log(`Invoking api/gameToResumeExistsForUnauthorizedUsers?msisdn=${rootState.common.unauthorizedMsisdn}`);
    return axios({
      method: 'get',
      url: `api/gameToResumeExistsForUnauthorizedUsers?msisdn=${rootState.common.unauthorizedMsisdn}`,
    }).catch((error) => {
      console.log(`Invoking api/checkIfGameToResumeExistsForUnauthorizedUsers failed with the following error: ${error}`);
    });
  },
  awardPrizeAction({ rootState }) {
    console.log('Invoking api/awardPrizeAction');
    return axios({
      method: 'get',
      url: `api/awardPrize?prizeId=${rootState.game.unauthorizedWinnerInfo.prizeId}&code=${rootState.game.unauthorizedWinnerInfo.code}`,
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log(response.data.responseEnum);
    }).catch((error) => {
      console.log(`Invoking api/awardPrizeAction failed with the following error: ${error}`);
    });
  },
  getAddOnGameStatus(_storeParams, { queryParams }) {
    return axios({
      method: 'get',
      url: 'api/getBonusAddOnGameAvailable',
      headers: {
        Authorization: auth.getJwt(),
      },
      params: queryParams,
    }).then((response) => {
      const responseEnum = response && response.data && response.data.responseEnum;
      return { canPlay: responseEnum === 'OPERATION_SUCCESS' };
    });
  },
  finishAddOnGame(_storeParams, payload) {
    return axios({
      method: 'post',
      url: 'api/updateDBonusAddOnGames',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: payload,
    }).then((response) => {
      const responseEnum = response && response.data && response.data.responseEnum;
      if (responseEnum !== 'OPERATION_SUCCESS') {
        return Promise.reject({ responseEnum });
      }
      const prizeValue = (response.data.data && !isNaN(+response.data.data.name) && isFinite(+response.data.data.name))
        ? +response.data.data.name
        : 0;
      return { prizeValue };
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/actions.js